import { NgModule } from '@angular/core';

import { ReportingRoutingModule } from './reporting-routing.module';
import { TripDashboardComponent } from './containers/trip-dashboard/trip-dashboard.component';
import { REPORTING_STATES } from './reporting.states';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../../shared/shared.module';
import { AutoCompleteQueryComponent } from './components/auto-complete-query/auto-complete-query.component';
import { IsQueryValidPipe } from './pipes/is-query-valid.pipe';
import { TrainsModule } from '../trains/trains.module';
import { TripDashboardStatsComponent } from './components/trip-dashboard-stats/trip-dashboard-stats.component';
import { TrainsSelectorFormComponent } from './components/trains-selector-form/trains-selector-form.component';
import { TripOverviewComponent } from "./containers/trip-overview/trip-overview.component";
import { TripDurationPipe } from './pipes/trip-duration.pipe';
import { SlaDocumentationComponent } from './components/sla-documentation/sla-documentation.component';
import { ParseTripSqiPipe } from './pipes/parse-trip-sqi.pipe';

@NgModule({
  declarations: [TripDashboardComponent, AutoCompleteQueryComponent, IsQueryValidPipe, TripDashboardStatsComponent, TrainsSelectorFormComponent, TripOverviewComponent, TripDurationPipe, SlaDocumentationComponent, ParseTripSqiPipe],
  imports: [
    SharedModule,
    ReportingRoutingModule,
    UIRouterModule.forChild({ states: [...REPORTING_STATES] }),
    TrainsModule
  ],
  providers: [TripDurationPipe]
})
export class ReportingModule { }
